<template>
  <div class="d-flex justify-space-between align-center field-select primary--text ">
    <div style="width: 160px; height: 100%">
      <v-btn :disabled="disabled" class="white--text" tile depressed small color="tertiary" style="height: 100%; width: 100px" @click="$emit('back')">
        Back
      </v-btn>
    </div>
    <div v-if="field.id" id="select-field-step-3" class="text-center">
      <div class="body-1 fs-exclude" style="line-height: 1">
        {{ field.field }}
      </div>
      <div v-if="field.original" style="font-size: 13px; line-height: 1" class="pt-1 fs-exclude">
        {{ field.original }}
      </div>
    </div>
    <div v-else class="flex-grow-1">
      <v-skeleton-loader value="true" type="text" class="mt-1" />
    </div>
    <div style="width: 160px; height: 100%" class="justify-end d-flex">
      <v-btn id="select-field-step-4" :disabled="field.completed || disabled" class="white--text mr-1" text small color="tertiary" style="height: 100%" @click="$emit('skip')">
        Skip
      </v-btn>
      <v-btn id="select-field-step-2" :disabled="disabled" class="white--text" tile small depressed color="tertiary" style="height: 100%; width: 100px" @click="$emit('next')">
        Next Field
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isReadOnly: { type: Boolean, default: false },
    field: { type: Object, required: true },
    current: { type: Number, default: 1 },
    total: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },
    type: { type: String, required: true }
  },
  computed: {
    showNext() {
      return this.total > this.current
    },
    showPrevious() {
      return this.current > 1
    },
    infoModalTitle() {
      return this.type === 'fields'
        ? 'Select Fields'
        : 'Translate Fields'
    }
  },
  methods: {
    previous() {
      this.$emit('back')
    },
    next() {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
.field-select {
  border-top: 1px solid var(--v-tertiary-base);
  border-bottom: 1px solid var(--v-tertiary-base);
  height: 56px;
}
</style>
